import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const SKILLS = [
  { icon: 'ri-mic-line', label: 'Mic Control', desc: 'Surgical precision on every bar — flow, timing, and presence unmatched.' },
  { icon: 'ri-quill-pen-line', label: 'Lyricism', desc: 'Out-of-this-world wordplay with multilayered storytelling and vivid imagery.' },
  { icon: 'ri-music-2-line', label: 'Delivery', desc: 'Mastered delivery that hits different — every punchline lands exactly right.' },
  { icon: 'ri-map-pin-line', label: 'IE Roots', desc: 'Born and raised in the Inland Empire, 909 in his DNA and every rhyme.' },
];

export default function About() {
  return (
    <div className="bg-brand-dark min-h-screen">
      <Navbar />
      <main className="pt-20">
        {/* Hero Banner */}
        <section className="relative w-full h-72 md:h-96 overflow-hidden flex items-end">
          <img
            src="https://public.readdy.ai/ai/img_res/67679f77815d542e1ddb342e2c58aee0.jpg"
            alt="About Banner"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-black/50 to-black/30" />
          <div className="relative z-10 px-6 md:px-12 pb-10 max-w-7xl mx-auto w-full">
            <p className="font-heading text-brand-orange tracking-[0.3em] uppercase text-xs mb-2">The Story</p>
            <h1 className="font-display text-6xl md:text-7xl text-white tracking-wide">ABOUT <span className="text-brand-yellow">DIRTY BIRDY</span></h1>
          </div>
        </section>

        {/* Bio + Photo */}
        <section className="py-20 px-6 md:px-12 bg-brand-dark">
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-14 items-start">
            <div className="flex flex-col gap-5">
              <div className="w-12 h-1 bg-brand-yellow" />
              <p className="font-body text-white/70 text-base leading-relaxed">
                Dirty Birdy is not just a rapper — he&apos;s a movement. Born and raised in the scorching concrete sprawl of California&apos;s Inland Empire by way of the city of San Bernardino. He absorbed the raw energy, the hustle, and the unfiltered truth of the 909 and channeled it all into his music.
              </p>
              <p className="font-body text-white/70 text-base leading-relaxed">
                His lyrics are out of this world — vivid, introspective, hard-hitting. His delivery is surgical, mastered over years of underground cyphers, studio sessions, and real-life battles. When Dirty Birdy grabs the mic, every room goes still.
              </p>
              <p className="font-body text-white/70 text-base leading-relaxed">
                Praised by fans and peers alike for his mic skills, he represents the true spirit of West Coast hip-hop — authentic, raw, and deeply rooted in the community that built him. He isn&apos;t just from the Inland Empire. He&apos;s the Inland Empire.
              </p>
              <blockquote className="border-l-4 border-brand-yellow pl-5 mt-2">
                <p className="font-display text-xl text-brand-yellow tracking-wide">&ldquo;I don&apos;t rYHME to be famous. I rYHME TO CARRY ON TRADITION.&rdquo;</p>
                <footer className="font-heading text-white/40 text-xs uppercase tracking-widest mt-2">— Dirty Birdy</footer>
              </blockquote>
            </div>
            <div className="relative">
              <div className="w-full h-0 pb-[120%] relative overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/39de9bd8f1de295932d81b4de403e80f.jpeg"
                  alt="Dirty Birdy"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-full h-full border-2 border-brand-orange pointer-events-none" />
            </div>
          </div>
        </section>

        {/* Skills - hidden */}
        <div className="hidden">
        <section className="py-16 px-6 md:px-12 bg-[#111111]">
          <div className="max-w-7xl mx-auto">
            <h2 className="font-display text-4xl md:text-5xl text-white tracking-wide mb-10">THE <span className="text-brand-yellow">SKILLS</span></h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {SKILLS.map((s) => (
                <div key={s.label} className="bg-brand-card p-6 border-t-2 border-brand-yellow">
                  <div className="w-10 h-10 flex items-center justify-center mb-4">
                    <i className={`${s.icon} text-brand-yellow text-2xl`} />
                  </div>
                  <h3 className="font-display text-2xl text-white mb-2">{s.label}</h3>
                  <p className="font-body text-white/50 text-sm leading-relaxed">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
